<template>
  <NotificationsBody/>
</template>

<script>
// @ is an alias to /src
import NotificationsBody from '@/components/NotificationsBody.vue'

export default {
  name: 'NotificationsView',
  components: {
    NotificationsBody
  }
}
</script>
